import React from 'react';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	changeMenuVersion: (value: string) => void;
}

export const MenuVersionField: React.FC<IProps> = React.memo(({ changeMenuVersion }) => (
	<FormInputNew
		testId="MenuVersionField"
		name="menuVersion"
		label="menuVersionLabel"
		placeholder="menuVersionPlaceholder"
		onChange={changeMenuVersion}
	/>
));
